import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/pages/Home';
import Login from '@/pages/Login';
import Admin from '@/pages/Admin';
import AdminHome from '@/pages/Admin/Home';
import AdminUser from '@/pages/Admin/User';
import AdminUserApply from '@/pages/Admin/User/Apply';
import AdminMenu from '@/pages/Admin/User/Menu';
import AdminProduct from '@/pages/Admin/Product';
import AdminProductType from '@/pages/Admin/Product/Type';
import AdminProductBrand from '@/pages/Admin/Product/Brand';
import AdminProductCdk from '@/pages/Admin/Product/Cdk';
import AdminExchangeOrder from '@/pages/Admin/Product/Order';
import AdminFinance from '@/pages/Admin/Finance';
import AdminFinanceWareHouse from '@/pages/Admin/Finance/Warehouse';
import AdminFinanceOutBound from '@/pages/Admin/Finance/Outbound';
import AdminSysUser from '@/pages/Admin/Sys';
import AdminSysNotice from '@/pages/Admin/Sys/Notice';
import AdminSysLunbo from '@/pages/Admin/Sys/Lunbo';
import AdminProductLottery from '@/pages/Admin/Product/Lottery';
import AdminAneArticle from '@/pages/Admin/Ane/Article';
import AdminAneNews from '@/pages/Admin/Ane/News';
import Shop from '@/pages/Shop';
import ShopHome from '@/pages/Home';
import ShopExchange from '@/pages/Shop/exchange';
import ShopDetail from '@/pages/Shop/detail';
import ShopLottery from '@/pages/Shop/lottery';
import User from '@/pages/User';
import UserApply from '@/pages/Apply';
import Firm from '@/pages/Firm';
import FirmInfo from '@/pages/Firm/Book/Info';
import FirmHome from '@/pages/Firm/Home';
import FirmStaff from '@/pages/Firm/Staff';
import FirmStaffRole from '@/pages/Firm/Staff/Role';
import FirmProduct from '@/pages/Firm/Product';
import FirmProductBrand from '@/pages/Firm/Product/Brand';
import FirmExchangeOrder from '@/pages/Firm/Product/Order';
import FirmProductCdk from '@/pages/Firm/Product/Cdk';
import FirmProductLottery from '@/pages/Firm/Product/Lottery';
import FirmCdkReceive from '@/pages/Firm/Product/Receive';
import FirmWareHouse from '@/pages/Firm/Finance/Warehouse';
import FirmOutBound from '@/pages/Firm/Finance/Outbound';
import FirmSet from '@/pages/Firm/Set';
import FirmNotice from '@/pages/Firm/Set/Notice';
import FirmLog from '@/pages/Firm/Log';
import FirmBook from '@/pages/Firm/Book';
import FirmBookUpload from '@/pages/Firm/Book/Upload';
import FirmBookImgup from '@/pages/Book/Imgup';
import Book from '@/pages/Book';
import BookUpload from '@/pages/Book/Upload';
import BookHome from '@/pages/Book/Home';
import BookPdf from '@/pages/Book/Pdf';
import Img2pdf2 from '@/pages/Firm/Book/Img';
import Img2pdf from '@/pages/Book/Img2pdf';
import Txt2Qr from '@/pages/Tools/Txt2qr';
import EmailBind from '@/pages/Email/Bind';
Vue.use(VueRouter);
const BookAsyncJsComponent = () => {
    import('../../public/js/pdf.mjs');
    import('../../public/js/pdf.worker.mjs');
    import('../../public/js/FileSaver.js');
    import('../../public/js/jszip.min.js');
}
export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            name: '官网首页',
            path: '/',
            component: Login,
            meta: {
                showIndex: '1',
                topShow: false,
                bottomShow: false,
                metaInfo: {
                    title: 'CNHONOR CATALOG-画册展示！',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '登录',
            path: '/home',
            component: Login,
            meta: {
                topShow: false,
                bottomShow: false,
                metaInfo: {
                    title: 'CNHONOR CATALOG-用户登录',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '后台',
            path: '/admin',
            component: Admin,
            redirect: '/admin/home',
            meta: {
                showIndex: '-1',
                topShow: false,
                bottomShow: false,
                metaInfo: {
                    title: 'CNHONOR CATALOG-后台管理',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            },
            children: [
                {
                    name: '后台首页',
                    path: 'home',
                    component: AdminHome,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-后台主页',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '用户管理',
                    path: 'user',
                    component: AdminUser,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-用户管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '菜单管理',
                    path: 'menu',
                    component: AdminMenu,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-菜单管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '商品管理',
                    path: 'product',
                    component: AdminProduct,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-商品管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '类型管理',
                    path: 'producttype',
                    component: AdminProductType,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-类型管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '品牌管理',
                    path: 'productbrand',
                    component: AdminProductBrand,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-品牌管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '兑换订单管理',
                    path: 'exorder',
                    component: AdminExchangeOrder,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-兑换订单管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '卡券管理',
                    path: 'cdk',
                    component: AdminProductCdk,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-卡券管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: 'admin-sys-user',
                    path: 'sysuser',
                    component: AdminSysUser,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-后台主页',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '财务管理',
                    path: 'finance',
                    component: AdminFinance,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-财务管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '入库查询',
                    path: 'warehouse',
                    component: AdminFinanceWareHouse,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-入库查询',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '出库查询',
                    path: 'outbound',
                    component: AdminFinanceOutBound,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-出库查询',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '系统通知管理',
                    path: 'notice',
                    component: AdminSysNotice,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-系统通知管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '抽奖活动管理',
                    path: 'lottery',
                    component: AdminProductLottery,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-抽奖活动管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司认证管理',
                    path: 'apply',
                    component: AdminUserApply,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司认证管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '轮播管理',
                    path: 'lunbo',
                    component: AdminSysLunbo,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-轮播管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '文章管理',
                    path: 'article',
                    component: AdminAneArticle,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-文章管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '新闻管理',
                    path: 'news',
                    component: AdminAneNews,
                    meta: {
                        metaInfo: {
                            title: 'CNHONOR CATALOG-新闻管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    path: '/admin*',
                    redirect: 'home'
                }
            ]
        },
        {
            name: '公司中心',
            path: '/firm',
            redirect: '/firm/home',
            component: Firm,
            meta: {
                showIndex: '-1',
                topShow: false,
                bottomShow: false,
                metaInfo: {
                    title: 'CNHONOR CATALOG-公司中心',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            },
            children: [
                {
                    name: '公司首页',
                    path: 'home',
                    component: FirmHome,
                    meta: {
                        pageId: -1,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司首页',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司画册管理',
                    path: 'book',
                    component: FirmBook,
                    meta: {
                        pageId: 24,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司画册管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司画册上传',
                    path: 'upload',
                    component: FirmBookUpload,
                    meta: {
                        pageId: 25,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司画册上传',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '图片画册上传',
                    path: 'imgup',
                    component: FirmBookImgup,
                    meta: {
                        pageId: 25,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-图片画册上传',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司角色管理',
                    path: 'role',
                    component: FirmStaffRole,
                    meta: {
                        pageId: 7,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司角色管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司员工管理',
                    path: 'staff',
                    component: FirmStaff,
                    meta: {
                        pageId: 15,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司员工管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司商品管理',
                    path: 'product',
                    component: FirmProduct,
                    meta: {
                        pageId: 9,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-商品管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司品牌管理',
                    path: 'productbrand',
                    component: FirmProductBrand,
                    meta: {
                        pageId: 10,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-品牌管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司兑换订单管理',
                    path: 'exorder',
                    component: FirmExchangeOrder,
                    meta: {
                        pageId: 12,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-兑换订单管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司卡券管理',
                    path: 'cdk',
                    component: FirmProductCdk,
                    meta: {
                        pageId: 11,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-卡券管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '卡券领用管理',
                    path: 'receive',
                    component: FirmCdkReceive,
                    meta: {
                        pageId: 18,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-卡券领用管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司抽奖活动管理',
                    path: 'lottery',
                    component: FirmProductLottery,
                    meta: {
                        pageId: 99,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-抽奖活动管理',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司系统设置',
                    path: 'set',
                    component: FirmSet,
                    meta: {
                        pageId: 21,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司系统设置',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司通知设置',
                    path: 'notice',
                    component: FirmNotice,
                    meta: {
                        pageId: 20,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司通知设置',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司入库记录',
                    path: 'warehouse',
                    component: FirmWareHouse,
                    meta: {
                        pageId: 16,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司入库记录',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司出库记录',
                    path: 'outbound',
                    component: FirmOutBound,
                    meta: {
                        pageId: 17,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司出库记录',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司日志记录',
                    path: 'log',
                    component: FirmLog,
                    meta: {
                        pageId: 22,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司日志记录',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: 'IMG转PDF',
                    path: 'img',
                    component: Img2pdf2,
                    meta: {
                        pageId: 22,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司日志记录',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    name: '公司信息',
                    path: 'info',
                    component: FirmInfo,
                    meta: {
                        pageId: 22,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-公司信息',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
                {
                    path: '/firm*',
                    redirect: '/firm/home'
                }
            ]
        },
        {
            name: '个人中心',
            path: '/user',
            component: User,
            meta: {
                showIndex: '-1',
                topShow: true,
                bottomShow: true,
                metaInfo: {
                    title: 'CNHONOR CATALOG-个人中心',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '公司申请',
            path: '/apply',
            component: UserApply,
            meta: {
                topShow: false,
                bottomShow: true,
                metaInfo: {
                    title: 'CNHONOR CATALOG-公司申请',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '画册展示',
            path: '/book/show/:id',
            component: BookPdf,
            meta: {
                topShow: false,
                bottomShow: false,
                metaInfo: {
                    title: 'CNHONOR CATALOG-画册展示',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '画册上传2',
            path: '/book/upload',
            component: BookUpload,
            meta: {
                topShow: false,
                bottomShow: false,
                metaInfo: {
                    title: 'CNHONOR CATALOG-画册展示',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '图片转PDF',
            path: '/book/img2pdf',
            component: Img2pdf,
            meta: {
                topShow: true,
                bottomShow: true,
                metaInfo: {
                    title: 'CNHONOR CATALOG-图片转PDF',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '二维码转换',
            path: '/tools/txt2qr',
            component: Txt2Qr,
            meta: {
                topShow: true,
                bottomShow: true,
                metaInfo: {
                    title: 'CNHONOR CATALOG-二维码转换',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: '邮箱绑定',
            path: '/email/bind',
            component: EmailBind,
            meta: {
                topShow: true,
                bottomShow: true,
                metaInfo: {
                    title: 'CNHONOR CATALOG-邮箱绑定',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            }
        },
        {
            name: 'PDF画册',
            path: '/book',
            redirect: '/book',
            component: Book,
            meta: {
                topShow: false,
                bottomShow: false,
                metaInfo: {
                    title: 'CNHONOR CATALOG-PDF画册',
                    keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                    description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                }
            },
            children: [
                {
                    name: '画册首页',
                    path: '/',
                    component: BookHome,
                    meta: {
                        pageId: -1,
                        metaInfo: {
                            title: 'CNHONOR CATALOG-画册首页',
                            keywords: 'CNHONOR CATALOG, 优惠券, 礼品卡, 自动发卡',
                            description: '汇聚优质品牌，提供便捷提货服务。一卡在手，畅享购物乐趣，让您轻松拥有心仪商品，体验尊贵品质生活。'
                        }
                    }
                },
            ]
        },
        {
            path: '*',
            redirect: '/'
        },
    ],
});